import React, { useCallback, useRef, useEffect } from "react";
import {MonthRangePicker} from '@viniarruda/react-month-range-picker'
import { RangeParams } from "@viniarruda/react-month-range-picker/types/MonthRangePicker/types";
import './month-range-picker.css';

// Definição das props esperadas
interface MonthRangePickerWrapperProps {
  dateRange: RangeParams;
  setDateRange: React.Dispatch<React.SetStateAction<RangeParams>>;
  onChange?: (range: RangeParams) => void;
  columns?: 1 | 2;
  locale?: string;
}

const MonthRangePickerWrapper: React.FC<MonthRangePickerWrapperProps> = ({
  dateRange,
  setDateRange,
  onChange = () => {},
  columns = 1,
  locale = "pt-BR"
}) => {
  const rangeRef = useRef(dateRange);

  // Mantém o valor atualizado sem recriar o handler
  useEffect(() => {
    rangeRef.current = dateRange;
  }, [dateRange]);

  const handleRangeSelect = useCallback((params: RangeParams) => {
    const current = rangeRef.current;

    if (
      current.startMonth === params.startMonth &&
      current.startYear === params.startYear &&
      current.endMonth === params.endMonth &&
      current.endYear === params.endYear
    ) {
      return; // Evita atualização redundante
    }

    setDateRange(params);
    onChange(params);

    
  }, [setDateRange]); // depende apenas do setter, que é estável

  return (
    <>
      <MonthRangePicker
        onRangeSelect={handleRangeSelect}
        columns={columns}
        locale={locale}
        monthClassName="month"
      />
    </>
    
  );
};

export default MonthRangePickerWrapper;